<template>
  <div class="mx-3 ma-4">
    <v-card class="pa-5">
      <v-card-title>Goods Received Notes</v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :loading="loading"
        :hide-default-footer="true"
        :disable-sort="true"
        :disable-pagination="true"
      >
        <template v-slot:item="{ item, index }">
          <tr :class="index % 2 === 0 ? 'dark-row' : 'light-row'" class="custom-row">
            <td class="text-left">{{ item.grn_number }}</td>
            <td class="text-left">{{ item.po_number }}</td>
            <td class="text-left">{{ item.grn_date }}</td>
            <td class="text-left">{{ item.items_count }}</td>
            <td class="text-left">{{ currencyCode }}{{ formatNumber(item.grand_total) }}</td>
          </tr>
        </template>
      </v-data-table>

      <v-alert v-if="!loading && items.length === 0" type="info" class="mt-5" outlined>
        No goods received notes found.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { SupplierService } from "@/services/supplier-service.js";

export default {
  name: "SupplierGoodsReceived",
  data() {
    return {
      items: [],
      loading: false,
      headers: [
        { text: "GRN Number", value: "grn_number", align: "start" },
        { text: "PO Number", value: "po_number", align: "start" },
        { text: "Date", value: "grn_date", align: "start" },
        { text: "Items Count", value: "items_count", align: "start" },
        { text: "Amount", value: "grand_total", align: "start" },
      ],
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    fetchData() {
      this.loading = true;
      SupplierService.getGoodsReceived(this.$route.params.uuid)
        .then((res) => {
          this.loading = false;
          this.items = res.data.data || [];
        })
        .catch(() => {
          this.loading = false;
          this.items = [];
        });
    },
  },
};
</script>

<style scoped>
.dark-row { background-color: #fafafa; }
.light-row { background-color: #ffffff; }
.custom-row { height: 60px; border: none; }
</style>
